"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var lodash_1 = __importDefault(require("lodash"));
var ApartmentTableRow_1 = __importDefault(require("./ApartmentTableRow"));
var TableHeader_1 = __importDefault(require("./TableHeader"));
var ApartmentTableContext_1 = require("../../../../../../contexts/ApartmentTableContext");
var currencyConverter_1 = require("../../../../../../helpers/currencyConverter");
var react_redux_1 = require("react-redux");
var currencySlice_1 = require("../../../../../../features/currencies/currencySlice");
var numberHelpers_1 = require("../../../../../../helpers/numberHelpers");
var sortReducer = function (state, action) {
    if (action.type === 'CHANGE_SORT') {
        return __assign(__assign({}, state), { column: action.payload.column, direction: action.payload.direction });
    }
    return state;
};
var ApartmentsTable = function (_a) {
    var apartments = _a.apartments, filters = _a.filters, postData = _a.postData, redirectToMortgageSection = _a.redirectToMortgageSection, setPostMedia = _a.setPostMedia, handleScrollToShowMobileMedias = _a.handleScrollToShowMobileMedias, isMortgageButtonClicked = _a.isMortgageButtonClicked, setIsMortgageButtonClicked = _a.setIsMortgageButtonClicked, isRent = _a.isRent;
    var _b = react_1.useContext(ApartmentTableContext_1.ApartmentContext), activeApartmentId = _b.activeApartmentId, setActiveApartmentId = _b.setActiveApartmentId;
    var rate = react_redux_1.useSelector(currencySlice_1.selectExchangeRate);
    var all = react_redux_1.useSelector(currencySlice_1.selectAllExchangeRates);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var _c = react_1.useReducer(sortReducer, {
        column: undefined,
        direction: undefined,
    }), _d = _c[0], column = _d.column, direction = _d.direction, dispatch = _c[1];
    react_1.useEffect(function () {
        isMortgageButtonClicked && setActiveApartmentId(sorted[0].entity_id);
    }, [isMortgageButtonClicked]);
    var onChangeSort = function (name) {
        dispatch({
            type: 'CHANGE_SORT',
            payload: {
                column: name,
                direction: column === name ? !direction : true,
            },
        });
    };
    var applyFilters = function () {
        return lodash_1.default.reduce(filters, function (acc, f, key) {
            if (!f || !f.length) {
                return acc;
            }
            return byFilters(acc, key, f);
        }, apartments);
    };
    var mapper = {
        lt: function (val, cond) { return parseInt(val) < parseInt(cond); },
        lte: function (val, cond) { return parseInt(val) <= parseInt(cond); },
        gt: function (val, cond) { return parseInt(val) > parseInt(cond); },
        gte: function (val, cond) { return parseInt(val) >= parseInt(cond); },
        eq: function (val, cond) { return val == cond; },
    };
    var byFilters = function (apts, key, v) {
        // Each filter is a multiselect, we need to run it for each one
        return v.reduce(function (acc, f) {
            var filtered = byFilter(apts, key, f);
            return lodash_1.default.uniqWith(__spreadArray(__spreadArray([], acc), filtered), lodash_1.default.isEqual);
        }, []);
    };
    var byFilter = function (apts, key, v) {
        var arr = v.split('~');
        var filter = arr.length === 2 ? arr[1] : arr[0];
        var parts = filter.split('-');
        return parts.reduce(function (acc, p) {
            var _a = p.split('_'), operator = _a[0], operand = _a[1];
            // We're dealing with a plain value here
            if (!operand) {
                operand = operator;
                operator = 'eq';
            }
            return acc.filter(function (a) {
                var value = a[key];
                if (!value) {
                    return true;
                }
                if (key === 'sqm_price') {
                    value = numberHelpers_1.revertCommaNumber(currencyConverter_1.convertToCurrency([{ price: value, currency: a.currency }], rate, all, currency));
                }
                return mapper[operator](value, operand);
            });
        }, apts);
    };
    var applySorting = function (apts) {
        if (!column) {
            return apts;
        }
        return __spreadArray([], apts).sort(function (a, b) {
            var firstAprtSortParam = a[column];
            var secondAprtSortParam = b[column];
            // checking the type of the sorting param for proper sorting
            if (!isNaN(Number(firstAprtSortParam))) {
                firstAprtSortParam = Number(firstAprtSortParam);
            }
            if (!isNaN(Number(secondAprtSortParam))) {
                secondAprtSortParam = Number(secondAprtSortParam);
            }
            // Ascending
            if (direction) {
                if (firstAprtSortParam < secondAprtSortParam) {
                    return -1;
                }
                if (firstAprtSortParam > secondAprtSortParam) {
                    return 1;
                }
                return 0;
            }
            // Descending
            if (firstAprtSortParam > secondAprtSortParam) {
                return -1;
            }
            if (firstAprtSortParam < secondAprtSortParam) {
                return 1;
            }
            return 0;
        });
    };
    var isExpanded = function (id) {
        return id === activeApartmentId;
    };
    var onToggle = function (id) {
        var newId = id === activeApartmentId ? undefined : id;
        setActiveApartmentId(newId);
        setIsMortgageButtonClicked(false);
    };
    var filtered = applyFilters();
    var sorted = applySorting(filtered);
    return (react_1.default.createElement(semantic_ui_react_1.Table, { compact: true, celled: true, definition: true, unstackable: true },
        react_1.default.createElement(TableHeader_1.default, { onChangeSort: onChangeSort, column: column, direction: direction }),
        react_1.default.createElement(semantic_ui_react_1.Table.Body, null, sorted.map(function (row, index) { return (react_1.default.createElement(ApartmentTableRow_1.default, { key: index, data: row, postData: postData, isExpanded: isExpanded(row.entity_id), onToggleCollapsible: onToggle, redirectToMortgageSection: redirectToMortgageSection, setPostMedia: setPostMedia, handleScrollToShowMobileMedias: handleScrollToShowMobileMedias, isRent: isRent })); }))));
};
exports.default = ApartmentsTable;
